module.exports = __webpack_public_path__ + "portal-static/img/zhibo.382f9c83.png";